
<template>
    <div>
        <md-card class="card_full_screen">
            <md-card-content>
                <ValidationObserver ref="valObserver">
                    <form>
                        <FadeTransition :duration="400" mode="out-in" v-if="!loading">
                            <div class="md-layout md-alignment-top-left">

                                  

                                <div class="md-layout-item md-small-size-100 md-medium-size-100 md-xlarge-size-100">
                                    <div class="title_with_btns">
                                        <div class="titles">
                                            <h3 class="zero_b_margin">{{website.name}}</h3>
                                            <p class="vertically_tight">{{website.address}} {{website.lat}} {{website.lng}}</p>
                                        </div>
                                        <website-menu></website-menu>
                                        <div class="btns">
                                            <div class="btns_sxs">
                                                <md-button class="md-danger" @click="seedGlobal" title="Fetch TFL etc pois regardless of location">Seed Global</md-button>
                                                <md-button class="md-danger" @click="seedBuilding" title="Fetch new pois for Building Radius">Seed Building</md-button>
                                                <md-button class="md-danger" @click="deleteBuildingsFile" title="Delete all Buildings Files">Delete Files</md-button>
                                                <md-button class="md-primary" @click="saveAll" title="Attempt to save all changes">Save All</md-button>
                                                <md-button class="md-primary" @click="upsertPoisAndCalc" title="Attempt to save all changes and complete remaining poi details">Save And Calc</md-button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="md-layout-item md-size-100 building-location poi_map">
                                        <div id="side_controls">
                                            <ul class="poi_types_list">
                                                <li v-for="poiType in website.poiTypes" :key="poiType.info.id">
                                                    <a @click="togglePoiType(poiType)" :class="{ selected : poiType.info.selected, active : (poiType === selectedPoiType) }">
                                                        <span class="icon" :class="poiType.info.markerColor"><i :class="poiType.info.defaultIcon"></i></span>
                                                        {{ poiType.info.name }}
                                                        ({{ poiType.items.length }})
                                                    </a>
                                                </li>
                                                <li> <a @click="toggleAllMarkers">Toggle All {{totalPois}}</a></li>
                                            </ul>
                                            <div class="btns_sxs">
                                                <a @click="previousPoi" title="Previous Poi" class="icon_link"><i class="fas fa-caret-left"></i></a>
                                                <a @click="nextPoi" title="Next Poi" class="icon_link"><i class="fas fa-caret-right"></i></a>
                                                <a @click="zoomAndCentre" title="Zoom and centre map (to mimic Sites default)" class="icon_link"><i class="fas fa-search-location"></i></a>
                                            </div>
                                            <h5 id="title_selectedType">{{selectedPoiTypeName}} </h5>
                                        </div>
                                        <div id="googlemap"></div>
                                    </div>
                                </div>

                                <div id="div_controls">
                                    <div>
                                        <ul id="ul_pois">
                                            <li v-for="poi in selectedPoiTypeItems" :key="poi.id">
                                                <a @click="selectPoiSimple(poi)" class="btn_selector" :class="{ active : (selectedPoi === poi) }">
                                                    <div>{{poi.name}}</div>
                                                    <div>
                                                        <span>{{poi.streetAddress}}</span><span class="postcode">{{poi.postcode}}</span>
                                                        <span>{{poi.countOtherBuildingAssociations}}</span>
                                                        <a v-on:click.self="toggleChosen(poi)" class="btn_choser" :class="{ excluded : poiExcluded(poi) }">{{(poiExcluded(poi))? "+" : "X" }}</a>
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div id="div_form">
                                        <div v-if="selectedPoi !== null">
                                            <div class="md-layout md-gutter">
                                                <label class="md-layout-item md-size-15 md-form-label">
                                                    Name
                                                </label>
                                                <div class="md-layout-item md-size-40">
                                                    <md-field>
                                                        <md-input v-model="selectedPoi.name" type="text" autocomplete="new-name" placeholder="Poi Name"></md-input>
                                                    </md-field>
                                                </div>
                                            </div>
                                            <div class="md-layout md-gutter">
                                                <label class="md-layout-item md-size-15 md-form-label">
                                                    Address
                                                </label>
                                                <div class="md-layout-item md-size-50">
                                                    <md-field>
                                                        <md-input v-model="selectedPoi.address" type="text" autocomplete="new-address" placeholder="Street Address"></md-input>
                                                    </md-field>
                                                </div>
                                            </div>
                                            <div class="md-layout md-gutter">
                                                <label class="md-layout-item md-size-15 md-form-label">
                                                    Postcode
                                                </label>
                                                <div class="md-layout-item md-size-20">
                                                    <md-field>
                                                        <md-input v-model="selectedPoi.postcode" type="text" autocomplete="new-postcode" placeholder="Postcode"></md-input>
                                                    </md-field>
                                                </div>
                                            </div>
                                            <div class="md-layout md-gutter">
                                                <label class="md-layout-item md-size-15 md-form-label">
                                                    Description
                                                </label>
                                                <div class="md-layout-item md-size-60">
                                                    <md-field>
                                                        <md-input v-model="selectedPoi.description" type="text" autocomplete="new-description" placeholder="Description"></md-input>
                                                    </md-field>
                                                </div>
                                            </div>
                                            <div class="md-layout md-gutter">
                                                <label class="md-layout-item md-size-15 md-form-label">
                                                    Chosen
                                                </label>
                                                <div class="md-layout-item md-size-20 pad_top">
                                                    <md-checkbox v-model="selectedPoi.chosen">Display on building site</md-checkbox>
                                                </div>
                                                <div class="md-layout-item md-size-20 pad_top">
                                                    <md-checkbox v-model="selectedPoi.deleted">Delete from all sites</md-checkbox>
                                                </div>
                                            </div>
                                            <div class="md-layout md-gutter">
                                                <label class="md-layout-item md-size-15 md-form-label">
                                                    Walk Min
                                                </label>
                                                <div class="md-layout-item md-size-10">
                                                    <md-field>
                                                        <md-input v-model="selectedPoi.walk" type="text"></md-input>
                                                    </md-field>
                                                </div>
                                                <div class="md-layout-item md-size-10">
                                                    <md-field>
                                                        <md-input v-model="selectedPoi.id" type="text" disabled></md-input>
                                                    </md-field>
                                                </div>
                                            </div>
                                            <div class="md-layout md-gutter">
                                                <label class="md-layout-item md-size-15 md-form-label">
                                                    Walk Metres
                                                </label>
                                                <div class="md-layout-item md-size-10">
                                                    <md-field>
                                                        <md-input v-model="selectedPoi.metres" type="text"></md-input>
                                                    </md-field>
                                                </div>
                                                <div class="md-layout-item md-size-70">
                                                    <md-field>
                                                        <md-input v-model="selectedPoi.url" type="text" placeholder="Url"></md-input>
                                                    </md-field>
                                                </div>
                                                  <div class="md-layout-item md-size-5 btns_sxs">
                                                        <a :href="selectedPoiUrl" :class="{ disabled : !poiHasUrl }" target="_blank">Url</a>
                                                </div>
                                            </div>

                                            <div class="md-layout md-gutter">
                                                <label class="md-layout-item md-size-15 md-form-label">
                                                    <a @click="togglePoiExtras">Extras</a>
                                                </label>
                                                <div class="md-layout-item md-size-60">
                                                    <div class="btns_sxs">
                                                        <a :href="selectedPoiGooglePlaceUrl" :class="{ disabled : !poiHasPlaceId }" target="_blank">Google Places</a>
                                                        <a :href="selectedPoiGoogleMapsUrl" target="_blank">Google Maps</a>
                                              
                                                        <a @click="toggleJson">Json</a>
                                                        <pre v-if="showJson">{{selectedPoiNonCircular}}</pre>
                                                    </div>
                                                </div>
                                            </div>


                                            <div v-if="showExtras" class="md-layout md-gutter">
                                                <label class="md-layout-item md-size-15 md-form-label">
                                                    GooglePlaceId | TflId
                                                </label>
                                                <div class="md-layout-item md-size-30">
                                                    <md-field>
                                                        <md-input v-model="selectedPoi.googlePlaceId" type="text" placeholder="googlePlaceId"></md-input>
                                                    </md-field>
                                                </div>
                                                <div class="md-layout-item md-size-30">
                                                    <md-field>
                                                        <md-input v-model="selectedPoi.tflId" type="text" placeholder="tflId"></md-input>
                                                    </md-field>
                                                </div>
                                                  <div class="md-layout-item md-size-10 btns_sxs">
                                                      <a :href="selectedPoiTflUrl" :class="{ disabled : !poiHasTflId}" target="_blank">Url</a>
                                                      <a :href="selectedPoiTflRailUrl" :class="{ disabled : !poiHasTflId}" target="_blank">Rail</a>
                                                </div>
                                            </div>

                                            <div v-if="showExtras" class="md-layout md-gutter">
                                                <label class="md-layout-item md-size-15 md-form-label">
                                                    Lat Lng
                                                </label>
                                                <div class="md-layout-item md-size-20">
                                                    <md-field>
                                                        <md-input v-model="selectedPoi.lat" type="text" placeholder="lat"></md-input>
                                                    </md-field>
                                                </div>
                                                <div class="md-layout-item md-size-20">
                                                    <md-field>
                                                        <md-input v-model="selectedPoi.lng" type="text" placeholder="lng"></md-input>
                                                    </md-field>
                                                </div>
                                            </div>

                                            <div v-if="showExtras" class="md-layout md-gutter">
                                                <label class="md-layout-item md-size-15 md-form-label">
                                                    Keyword
                                                </label>
                                                <div class="md-layout-item md-size-20">
                                                    <md-field>
                                                        <md-input v-model="placesKeyword" type="text" placeholder="Keyword"></md-input>
                                                    </md-field>
                                                </div>
                                                <div class="md-layout-item md-size-20">
                                                    <md-field>
                                                        <md-input v-model="placesRadius" type="text" placeholder="Radius in m"></md-input>
                                                    </md-field>
                                                </div>
                                                <div class="md-layout-item md-size-20">
                                                    <md-button class="md-info" @click="getPlacesAddress" title="Uses lat lng (server), keyword (e.g. cycle), radius to run G Place search to try to get address and googlePlaceId">Places Search</md-button>
                                                </div>
                                            </div>


                                            <div class="md-layout md-gutter">
                                                <div class="md-layout-item md-size-15">
                                                </div>
                                                <div class="md-layout-item md-size-60">
                                                    <div class="btns_sxs">
                                                        <md-button class="md-info" @click="getPlaceDetails" title="Fetches (cleaned up) address postcode url from google place Id">Get Place Details</md-button>
                                                        <md-button class="md-info" @click="getWalk" title="Fetch walk (mins, metres) from server's locations for building and poi">Get Walk</md-button>
                                                        <md-button class="md-info" @click="reverseGeocode" title="Fetch address postcode and google placeId from server lng lat for poid">R Geocode</md-button>
                                                        <md-button class="md-info" @click="getTflAddress" title="Fetch TFL's address and postcode for Bikes, Tubes, DLR, Overgrounds">TFL Address</md-button>
                                                        <md-button class="md-info" @click="refreshPopup" title="Refreshes map popup with current values">Popup</md-button>
                                                        <md-button class="md-info" @click="revertPoi" title="Revert this poi (to state when it was last selected)">Revert</md-button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>



                                <div id="div_links_admin">
                                    <div>
                                        <ul id="ul_link_groups">
                                            <li v-for="group in website.linkGroups" :key="group.enum" :class="{ active : (group === selectedLinkGroup) }">
                                                <a @click="selectLinkGroup(group)">
                                                    {{group.name}}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-if="selectedLinkGroup !== null">
                                        <div id="div_types">
                                            <div v-for="type in selectedLinkGroup.linkTypes" :key="type.enum" :class="{ active : (type === selectedLinkType) }" class="div_types_list">
                                                <h3 @click="selectLinkType(type)">{{type.name}}</h3>
                                                <div class="div_links">
                                                    <div v-for="(link, i) in type.links" :key="i">
                                                        <div class="md-layout md-gutter">
                                                            <label class="md-layout-item md-size-15 md-form-label">
                                                                Text
                                                            </label>
                                                            <div class="md-layout-item md-size-80">
                                                                <md-field>
                                                                    <md-input v-model="link.text" autocomplete="new-text" placeholder="Text"></md-input>
                                                                     <a @click="removeLink(type, link)" title="Delete this link" class="icon_link"><i class="far fa-trash-alt"></i></a>
                                                                </md-field>
                                                            </div>
                                                        </div>

                                                        <div class="md-layout md-gutter">
                                                            <label class="md-layout-item md-size-15 md-form-label">
                                                                Url
                                                            </label>
                                                            <div class="md-layout-item md-size-80">
                                                                <md-field>
                                                                    <md-input v-model="link.url" autocomplete="new-url" placeholder="Url"></md-input>
                                                                    <a :href="link.url" v-if="link.url != null && link.url.length > 5" target="_blank" title="Visit link" class="icon_link"><i class="fas fa-caret-right"></i></a>
                                                                </md-field>
                                                            </div>
                                                        </div>

                                                        <div class="md-layout md-gutter">
                                                            <label class="md-layout-item md-size-15 md-form-label">
                                                                Title
                                                            </label>
                                                            <div class="md-layout-item md-size-80">
                                                                <md-field>
                                                                    <md-input v-model="link.title" autocomplete="new-title" placeholder="Title"></md-input>
                                                                    <a @click="addLinkTitle(link)"  v-if="link.text != null && link.text.length > 5" title="Auto calc link title" class="icon_link"><i class="fas fa-caret-down"></i></a>
                                                                </md-field>
                                                            </div>
                                                        </div>
                                                    </div>
                                                           <a @click="addLink(type)" title="Add blank link for manual entry" class="icon_link"><i class="fas fa-plus"></i></a>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div id="div_searcher">
                                    <div id="div_search_input">
                                        <div class="md-layout md-gutter">
                                            <label class="md-layout-item md-size-15 md-form-label">
                                                Lat Lng
                                            </label>
                                            <div class="md-layout-item md-size-20">
                                                <md-field>
                                                    <md-input v-model="search.lat" placeholder="lat"></md-input>
                                                </md-field>
                                            </div>
                                            <div class="md-layout-item md-size-20">
                                                <md-field>
                                                    <md-input v-model="search.lng" placeholder="lng"></md-input>
                                                </md-field>
                                            </div>
                                        </div>

                                        <div class="md-layout md-gutter">
                                            <label class="md-layout-item md-size-15 md-form-label">
                                                Keyword(s)
                                            </label>
                                            <div class="md-layout-item md-size-20">
                                                <md-field>
                                                    <md-input v-model="search.keyword" placeholder="Keyword"></md-input>
                                                </md-field>
                                            </div>
                                            <div class="md-layout-item md-size-20">
                                                <md-field>
                                                    <md-input v-model="search.radius" placeholder="Radius in m"></md-input>
                                                </md-field>
                                            </div>
                                            <div class="md-layout-item md-size-20">
                                                <md-button class="md-info" @click="textSearch" title="Uses lat lng, keyword (e.g. cycle), radius to run G Place Text Search">Text Search</md-button>
                                            </div>
                                        </div>
                                    </div>


                                    <div id="div_search_results">
                                        <h4>{{linkAdditionTarget}}</h4>
                                        <div id="div_search_results_list">
                                            <table class="admin_text_search_results">
                                                <thead>
                                                    <tr>
                                                        <th class="sized_col">name</th>
                                                        <th class="min_col">actions</th>
                                                        <th class="min_col">rating</th>
                                                        <th class="min_col" title="user_ratings_total">total</th>
                                                        <th class="min_col">ratio</th>
                                                        <th class="min_col">url</th>
                                                        <th class="min_col">maps</th>
                                                        <th class="min_col">address</th>
                                                        <th class="min_col">lat</th>
                                                        <th class="min_col">lng</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="item in searchResults" :key="item.place_id">
                                                        <td class="sized_col">{{item.name}}</td>
                                                        <td class="min_col">
                                                            <a @click="getUrlFromPlaces(item)" title="Fetch Website from g places" class="icon_link"><i class="fas fa-caret-down"></i></a>
                                                            <a @click="addLinkFromSearchResult(item)" :title="'Add Link to ' + linkAdditionTarget" class="icon_link"><i class="fas fa-plus"></i></a>
                                                        </td>
                                                        <td class="min_col col_r_al">{{(item.rating || 0).toFixed(1)}}</td>
                                                        <td class="min_col col_r_al">{{item.user_ratings_total}}</td>
                                                        <td class="min_col col_r_al">{{((item.user_ratings_total/ (item.rating || 1))).toFixed(1)}}</td>
                                                        <td class="min_col">{{item.url}} <a :href="item.url" v-if="item.url != null && item.url.length > 5" target="_blank" class="icon_link"><i class="fas fa-caret-right"></i></a></td>
                                                        <td class="min_col"><a :href="getPlacesUrl(item.place_id)" title="Visit google places url" target="_blank" class="icon_link"><i class="fab fa-google"></i></a></td>
                                                        <td class="min_col">{{item.formatted_address}}</td>
                                                        <td class="min_col">{{item.geometry.location.lat.toFixed(4)}}</td>
                                                        <td class="min_col">{{item.geometry.location.lng.toFixed(4)}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <a @click="search.showJson = !search.showJson">Json</a>
                                        <pre v-if="search.showJson">{{searchResults}}</pre>
                                    </div>
                                </div>

                            </div>
                        </FadeTransition>
                        <div class="loader_wrap" v-if="loading">
                            <loader></loader>
                        </div>




                    </form>
                </ValidationObserver>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
    import { FadeTransition } from "vue2-transitions";
    import Loader from "@/components/Loader.vue";

    import Help from "@/ts/Help";
    import NotyTypes from "@/ts/NotyTypes";
    import Api from '@/ts/UvApiService';

    import getCurrentConfig from "@/ts/customConfig";
    import { Loader as GoogleLoader } from "google-maps";
    const googleLoader = new GoogleLoader(getCurrentConfig().googleMapsApiKey);

    import greyStyles from "@/ts/googleMapsGreyStyles.json";

    import { MapHelp } from "@/ts/MapHelp";
    import GMapsHelp from "@/ts/GMapsHelp";

    import Swal from "sweetalert2";
    import WebsiteMenu from "./WebsiteMenu.vue";

    export default {  
        components: {
            Loader
            , FadeTransition
            , WebsiteMenu
        },
        data() {
            return {
                loading: true,
                website: null,
                google: null,
                markers: [],
                buildingMarker: null,
                currentPopup: null,
                infoWindow: null,
                selectedPoiType: null,
                selectedPoi: null,
                showJson: false,
                showExtras: false,
                placesKeyword: 'cycle',
                placesRadius: 50,
                //links
                selectedLinkGroup: null,
                selectedLinkType: null,
                //searching
                search: {
                    lat: null,
                    lng: null,
                    radius: 850,
                    keyword: "dry cleaner",
                    showJson: false
                },
                searchResults: [],
                panorama: null
            }
        },
        computed: {
            totalPois() {
                let res = 0;
                if (!Help.isNullOrUndef(this.website.poiTypes)) {
                    var numberForEachPoiType = this.website.poiTypes.map(function (poiType) { return poiType.items.length; });
                    res = Help.sumArray(numberForEachPoiType);
                }
                return res;
            },
            poiHasPlaceId() { return (!Help.isNullOrUndef(this.selectedPoi) && Help.isGoodString(this.selectedPoi.googlePlaceId)); },
            poiHasUrl() { return (!Help.isNullOrUndef(this.selectedPoi)) && Help.isGoodString(this.selectedPoi.url); },//  (!Help.isNullOrUndef(this.selectedPoi) && !Help.isNullOrUndef(this.selectedPoi.url)); },
            poiHasTflId() { return (!Help.isNullOrUndef(this.selectedPoi)) && Help.isGoodString(this.selectedPoi.tflId); },
            selectedPoiGooglePlaceUrl() { return this.poiHasPlaceId ? `https://www.google.com/maps/place/?q=place_id:${this.selectedPoi.googlePlaceId}` : null; },
            selectedPoiGoogleMapsUrl() { return !Help.isNullOrUndef(this.selectedPoi) ? `https://www.google.com/maps/search/?api=1&query=${this.selectedPoi.lat},${this.selectedPoi.lng}` : null; },
            selectedPoiUrl() { return this.poiHasUrl ? `${this.selectedPoi.url}` : null; },
            selectedPoiTflUrl() { return this.poiHasTflId ? `https://tfl.gov.uk/stop/${this.selectedPoi.tflId}` : null; },
            selectedPoiTflRailUrl() { return this.poiHasTflId ? `https://tfl.gov.uk/national-rail/stop/${this.selectedPoi.tflId}` : null; },
            selectedPoiNonCircular() { return Help.cloneExceptKey(this.selectedPoi, "marker"); },
            selectedPoiTypeItems() { return Help.isNullOrUndef(this.selectedPoiType) ? [] : this.selectedPoiType.items; },
            selectedPoiTypeName() { return Help.isNullOrUndef(this.selectedPoiType) ? "" : this.selectedPoiType.info.name; },
            linkAdditionTarget() { return `${(this.selectedLinkGroup?.name ?? "N/A")} > ${this.selectedLinkType?.name ?? "N/A"}`; }
        },
        methods: {
            poiExcluded(poi) {
                return poi.chosen === false || poi.deleted === true;
            },
            removeLink(type, link) {
                Help.removeItemFromArray(type.links, link); //?? eh Help.removeItemFromArray(link);
            },
            addLinkTitle(link) {
                link.title = `More about ${link.text}...`;
            },
            getPlacesUrl(googlePlaceId) {
                return `https://www.google.com/maps/place/?q=place_id:${googlePlaceId}`;
            },
            async textSearch() {
                var res = await Api.websites.textSearch(this.search.lat, this.search.lng, this.search.radius, encodeURI(this.search.keyword));
                this.searchResults = res.sort((a, b) => {
                    if (a.rating > b.rating) return -1;
                    if (a.rating < b.rating) return 1;

                    if (a.user_ratings_total > b.user_ratings_total) return -1;
                    if (a.user_ratings_total < b.user_ratings_total) return 1;
                });
            },
            addLinkFromSearchResult(item) {
                if (Help.isNullOrUndef(this.selectedLinkType) || Help.isNullOrUndef(this.selectLinkGroup)) {
                    alert("Please select target link group and type first");
                }
                else {
                    this.selectedLinkType.links.push(
                        {
                            id: 0,
                            text: item.name,
                            url: item.url,
                            title: `More about ${item.name}...`,
                            poiId: null
                        }
                    );
                }
            },
            addLink(type) {
                type.links.push({
                    id: 0,
                    text: "",
                    url: "",
                    title: "",
                    poiId: null
                });
            },
            revertPoi() {
                this.selectedPoi.name = this.selectedPoiCopy.name;
                this.selectedPoi.lat = this.selectedPoiCopy.lat;
                this.selectedPoi.lng = this.selectedPoiCopy.lng;
                this.selectedPoi.address = this.selectedPoiCopy.address;
                this.selectedPoi.postcode = this.selectedPoiCopy.postcode;
                this.selectedPoi.walk = this.selectedPoiCopy.walk;
                this.selectedPoi.metres = this.selectedPoiCopy.metres;
                this.selectedPoi.chosen = this.selectedPoiCopy.chosen;
                this.selectedPoi.url = this.selectedPoiCopy.url;
                this.selectedPoi.googlePlaceId = this.selectedPoiCopy.googlePlaceId;
                this.selectedPoi.tflId = this.selectedPoiCopy.tflId;
                this.selectedPoi.deleted = this.selectedPoiCopy.deleted;
                this.selectedPoi.description = this.selectedPoiCopy.description;
            },
            togglePoiExtras() {
                this.showExtras = !this.showExtras;
            },
            async getTflAddress() {
                var res = await Api.websites.getTflAddress(this.selectedPoi.tflId);
                if (!Help.isGoodString(res.address) || !Help.isGoodString(res.postcode)) {
                    alert("NOT changing address and postcode as one was empty see console");
                    //console.log(res);
                }
                else {
                    this.selectedPoi.address = res.address;
                    this.selectedPoi.postcode = res.postcode;
                }
            },
            async getWalk() {
                var res = await Api.websites.getWalk(this.website.id, this.selectedPoi.id);
                this.selectedPoi.walk = res.walk;
                this.selectedPoi.metres = res.metres;
            },
            async reverseGeocode() { //reverse geocode
                var res = await Api.websites.reverseGeocode(this.selectedPoi.id);
                this.selectedPoi.address = res.address;
                this.selectedPoi.postcode = res.postcode;
                this.selectedPoi.googlePlaceId = res.googlePlaceId;
            },
            refreshPopup() {
                this.selectPoiSimple(this.selectedPoi);
            },
            toggleJson() {
                this.showJson = !this.showJson;
            },
            async getUrlFromPlaces(searchResult) {
                var res = await Api.websites.getPlaceDetails(searchResult.place_id);
                //console.log(res);
                var urlToAdd = res.website;
                if (!Help.isGoodString(res.website)) {
                    //console.log("no website adding cid url");
                    urlToAdd = res.googleCIdUrl;
                }
                this.$set(searchResult, 'url', urlToAdd);
            },
            async getPlaceDetails() {
                var res = await Api.websites.getPlaceDetails(this.selectedPoi.googlePlaceId);
                this.selectedPoi.address = res.address;
                this.selectedPoi.postcode = res.postcode;
                this.selectedPoi.url = res.website;
                //console.log(res.googleCIdUrl);
            },
            async getPlacesAddress() {
                var res = await Api.websites.getPlacesAddress(this.selectedPoi.id, this.placesKeyword, this.placesRadius);
                this.selectedPoi.address = res.address;
                this.selectedPoi.googlePlaceId = res.googlePlaceId;
            },
            async seedGlobal() {
                Swal.fire({
                    title: "Are you sure?",
                    text: `This only needs to be done once for the whole system!`,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "md-button md-success btn-fill",
                    cancelButtonClass: "md-button md-danger btn-fill",
                    confirmButtonText: "Yes, it's not been done!",
                    buttonsStyling: false
                }).then(async result => {
                    if (result.value) {
                        var res = await Api.websites.seedGlobal();
                        //console.log(res);
                    }
                });
            },
            async seedBuilding() {
                 Swal.fire({
                    title: "Are you sure?",
                    text: `This only needs to be done once for the building`,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "md-button md-success btn-fill",
                    cancelButtonClass: "md-button md-danger btn-fill",
                    confirmButtonText: "Yes, it's not been done!",
                    buttonsStyling: false
                }).then(async result => {
                    if (result.value) {
                        var res = await Api.websites.seedBuilding(this.website.id);
                        //console.log(res);
                    }
                });
            },
            async deleteBuildingsFile() {
                Swal.fire({
                    title: "Are you sure?",
                    text: `This will remove all file associations, file rows and delete all actual files on HDD (except assigned tenant logos)`,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "md-button md-success btn-fill",
                    cancelButtonClass: "md-button md-danger btn-fill",
                    confirmButtonText: "Yes, all files are backed up (or not needed)!",
                    buttonsStyling: false
                }).then(async result => {
                    if (result.value) {
                        var res = await Api.websites.deleteBuildingsFiles(this.website.id);
                        this.handleServerResponse(res, "Deletin Buildings Files");
                    }
                });
            },
            previousPoi() {
                var iPoi = this.selectedPoiType.items.indexOf(this.selectedPoi);
                var previousIndexPoi = (iPoi - 1);
                if (previousIndexPoi >= 0) {
                    var newPoi = this.selectedPoiType.items[previousIndexPoi];
                    this.selectPoiSimple(newPoi);
                }
                else {
                    var iType = this.website.poiTypes.indexOf(this.selectedPoiType);
                    var previousIndexType = (iType - 1);
                    if (previousIndexType >= 0) {
                        var newType = this.website.poiTypes[previousIndexType];
                        this.selectPoiType(newType);
                        var newPoi = Help.last(newType.items);
                        this.selectPoiSimple(newPoi);
                    }
                    else {
                        var newType = Help.last(this.website.poiTypes);
                        this.selectPoiType(newType);
                        var newPoi = Help.first(newType.items);
                        this.selectPoiSimple(newPoi);
                    }
                }
            },
            nextPoi() {
                if (Help.isNullOrUndef(this.selectedPoiType)) {
                    this.selectPoiType(Help.first(this.website.poiTypes));
                }
                var iPoi = this.selectedPoiType.items.indexOf(this.selectedPoi);
                var nextIndexPoi = (iPoi + 1);
                if (this.selectedPoiType.items.length > nextIndexPoi) {
                    var newPoi = this.selectedPoiType.items[nextIndexPoi];
                    this.selectPoiSimple(newPoi);
                }
                else {
                    var iType = this.website.poiTypes.indexOf(this.selectedPoiType);
                    var nextIndexType = (iType + 1);
                    if (this.website.poiTypes.length > nextIndexType) {
                        var newType = this.website.poiTypes[nextIndexType];
                        this.selectPoiType(newType);
                        var newPoi = Help.first(newType.items);
                        this.selectPoiSimple(newPoi);
                    }
                    else {
                        var newType = Help.first(this.website.poiTypes);
                        this.selectPoiType(newType);
                        var newPoi = Help.first(newType.items);
                        this.selectPoiSimple(newPoi);
                    }
                }
            },
            toggleChosen(poi) {
                var excluded = (poi.chosen === false);
                poi.chosen = excluded;
            },
            selectPoi(poi, info, marker) {
                var htmlContent = MapHelp.getPopupHtml(poi, info);
                this.infoWindow.setContent(htmlContent);
                this.infoWindow.open(this.map, marker);
                this.selectedPoiCopy = Help.cloneObject(poi);
                this.selectedPoi = poi;
                this.placesKeyword = poi.name;
            },
            selectPoiSimple(poi) {
                if (!Help.isNullOrUndef(poi))
                    this.selectPoi(poi, this.selectedPoiType.info, poi.marker);
            },
            toggleAllMarkers() {
                var selected = Help.first(this.website.poiTypes).info.selected;
                this.website.poiTypes.forEach(t => {
                    t.info.selected = selected;
                    this.togglePoiType(t);
                })
            },
            selectPoiType(poiType) {
                poiType.info.selected = true;
                this.selectedPoiType = poiType;
                poiType.items.forEach(p => p.marker.setMap(this.map));
            },
            togglePoiType(poiType) {
                poiType.info.selected = !poiType.info.selected;
                var mapToSet = null;
                if (poiType.info.selected) {
                    this.selectedPoiType = poiType;
                    mapToSet = this.map;
                }
                else
                    this.selectedPoiType = null;
                poiType.items.forEach(p => p.marker.setMap(mapToSet));
            },
            selectLinkGroup(group) {
                this.selectedLinkGroup = group;
                this.selectedLinkType = null;
            },
            selectLinkType(type) {
                this.selectedLinkType = type;
                this.search.keyword = type.name.replace('/', ' and ');
            },
            async fetchData() {
                if (!Help.isNullOrUndef(this.$route.params.buildingId)) {
                    if (Help.isNullOrUndef(this.website)) {
                        var res = await Api.websites.getPois(this.$route.params.buildingId);
                        this.website = res;
                        this.search.lat = this.website.lat;
                        this.search.lng = this.website.lng;
                    }
                    this.loading = false;
                }
            },
            setupMap(google, self) {
                self.google = google;
                const myLatlng = new google.maps.LatLng(self.website.lat, self.website.lng);
                self.map = new window.google.maps.Map(document.getElementById("googlemap"), { zoom: GMapsHelp.zoomLevelDefault, center: myLatlng, styles: greyStyles });
                self.buildingMarker = new window.google.maps.Marker({ position: myLatlng, title: self.website.name, draggable: true });
                self.buildingMarker.setMap(self.map);
                //self.map.addListener("zoom_changed", () => { console.log("zoom_changed " + self.map.getZoom()); });
                self.infoWindow = new google.maps.InfoWindow({ content: `<h1>This should not be seen</h1>`, });
                for (var i = 0; i < self.website.poiTypes.length; i++) {
                    var poiType = self.website.poiTypes[i];
                    for (var x = 0; x < poiType.items.length; x++) {
                        var poi = poiType.items[x];
                        var marker = GMapsHelp.createMarker(poi, poiType.info, this.map, this.infoWindow, this.selectPoi);
                        poi.marker = marker;
                        this.markers.push(marker);
                    }
                }

                google.maps.event.addListener(self.infoWindow, 'domready', function() {
                    //console.log("info window dom ready");// whatever you want to do once the DOM is ready
                    let tflLinesContent = document.querySelectorAll('.tfl_lines[data-tflId]');
                    if (tflLinesContent.length > 0) {
                            let tflElement = tflLinesContent[0];
                            let tflId = tflElement.getAttribute("data-tflId");
                            if (Help.isGoodString(tflId)) {
                                tflElement.innerHTML = '<img class="img_tflloader" src="/images/tfl_loader.svg">';
                                self.getTflLineStatus(tflId, tflElement);
                            }
                    }
                    let santanderBikesContent = document.querySelectorAll('.bike_dock[data-tflId]');
                    if (santanderBikesContent.length > 0) {
                            let tflElement = santanderBikesContent[0];
                            let tflId = tflElement.getAttribute("data-tflId");
                            if (Help.isGoodString(tflId)) {
                                tflElement.innerHTML = '<img class="img_tflloader" src="/images/tfl_loader.svg">';
                                self.getTflBikeStatus(tflId, tflElement);
                            }
                        }
                });

                var firstPoiType = Help.first(self.website.poiTypes);
                var firstPoi = Help.first(firstPoiType.items);
                self.togglePoiType(firstPoiType);
                self.selectPoiSimple(firstPoi);
            },
            async getTflLineStatus(tflId, tflElement) {
                //console.log("going to get status for tflId " + tflId);
                var res = await Api.websites.getTflLineStatus(tflId);
                let tflLinesHtml = MapHelp.getLineStatusHtml(res);
                tflElement.innerHTML = tflLinesHtml;
            },
            async getTflBikeStatus(tflId, tflElement) {
                //console.log("going to get BIKE status for tflId " + tflId);
                var res = await Api.websites.getTflBikeStatus(tflId);
                let tflBikesHtml = MapHelp.getBikeRackStatusHtml(res);
                tflElement.innerHTML = tflBikesHtml;
            },
            zoomAndCentre() {
                this.google.maps.event.trigger(this.map, "resize");
                this.map.panTo(this.buildingMarker.getPosition());
                this.map.setZoom(this.website.siteMapZoom);//GMapsHelp.zoomLevelForSitesMap);//here.
            },
            async saveAll() {
                this.clearMarkersFromPoisForSave();
                //console.log("saveAll check");
                //console.log(this.website);
                var res = await Api.websites.upsertPois(this.website);
                if (res.success === true) {
                    alert("that worked");
                }
                else {
                    this.showServerFailMessage(res, "saving all");
                }
            },
            async upsertPoisAndCalc(){
                this.clearMarkersFromPoisForSave();
                var res = await Api.websites.upsertPoisAndCalc(this.website);
                if (res.success === true) {
                    alert("that worked");
                    //console.log(res.details);
                }
                else {
                    this.showServerFailMessage(res, "saving all");
                }
            },
            showServerFailMessage(res, action) {
                var msg = res.message ?? `Unknown problem on the server ${action} this building`;
                this.$notify({
                    timeout: 10000,
                    message: msg,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            clearMarkersFromPoisForSave() {
                var newTypes = [];
                this.website.poiTypes.forEach(t => {
                    var newitems = t.items.map(p => Help.cloneExceptKey(p, "marker"));
                    var newType = t;
                    newType.items = newitems;
                    newTypes.push(newType);
                });
                this.website.poiTypes = newTypes;
            },
            handleServerResponse(res, action) {
                if (res.success === true) {
                    alert(`SUCCESS: ${res.message}`);
                }
                else {
                    this.showServerFailMessage(res, action);
                }
            }
        },
        async mounted() {
            await this.fetchData();
            var self = this;
            if (window.google && window.google.maps) {
                //console.log("maps already loaded");
                self.setupMap(window.google, self);
            }
            else {
                googleLoader.load().then(function (google) {
                    self.setupMap(google, self);
                });
            }

            this._keyListener = function (e) {
                if (e.key === "ArrowLeft" && e.altKey) { //(e.ctrlKey || e.metaKey)) {
                    e.preventDefault();
                    this.previousPoi();
                }
                else if (e.key === "ArrowRight" && e.altKey) { //(e.ctrlKey || e.metaKey)) {
                    e.preventDefault();
                    this.nextPoi();
                }
            };
            document.addEventListener('keydown', this._keyListener.bind(this));
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this._keyListener);
        }
    }
</script>
<style lang="scss">
</style>

<!--jQuery('a[target^="_new"]').click(function() {
    var width = window.innerWidth * 0.66 ;
    // define the height in
    var height = width * window.innerHeight / window.innerWidth ;
    // Ratio the hight to the width as the user screen ratio
    window.open(this.href , 'newwindow', 'width=' + width + ', height=' + height + ', top=' + ((window.innerHeight - height) / 2) + ', left=' + ((window.innerWidth - width) / 2));
});-->
